<template >
    <div class="row">
        <div class="col-12 mb-4">
           <v-card>
                <h3 class="col-md-12 pt-0 mb-0">
                    <v-btn @click="$router.go(-1)" outlined class="btn-light" style="border: none;margin-right: 10px" title="Retour"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>
                    Activation de service.</h3>
                <div class="col-lg-12 pt-0 mt-0">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="col-md-12 bg-white">
                                <h5>Nom & Prénom</h5>
                                <h3><strong>{{ userData._first_name }} {{ userData._last_name }}</strong></h3>
                            </div>
                            </div>
                        <div class="col-md-4">
                            <div class="col-md-12 bg-white">
                                <h5>Référence : </h5>
                                <h3><strong>{{ userData._id }}</strong></h3>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="col-md-12 bg-white">
                                <h5>Email : </h5>
                                <h3><strong>{{ userData._email }}</strong></h3>
                            </div>
                        </div>
                    </div>
                </div>
                 <v-card-title>Services</v-card-title>
                <p class="col-md-12 pt-0 pb-0 mb-0 mt-0">Liste des services disponibles actif et inactif pour l'utilisateur</p>
               
                <div class="col-md-12 pt-0 mt-0">
                    <div class="row">
                        <div class="col-md-3 col-lg-3 col-12" v-for="(service, index) in serviceData" :key="index">
                            <div class="col-md-12 bg-white">
                                <img :src="img_url+''+service._logo" width="70px" height="70px" alt="">
                                <div class="mt-2">Cliquez pour activer ou désactiver</div>
                                <v-switch class="mt-2 pt-0 mb-0 pb-0"
                                    v-model="userServices"
                                    @click="handleUserServiceActivation(service,userData)" 
                                    :label="service._name"
                                    :value="service._id">
                                </v-switch>
                                <p :title="service._description">{{ limiText(service._description,50) }}</p>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
        import {mapState} from "vuex";
        import * as Swal from "sweetalert2";
        import {client} from "@/store/services/client";
        import {env} from '../../../../env.js'
    export default {
        label: "userServices",
        data () {
            return {
            serviceData: undefined,
            userId: undefined,
            serviceId: undefined,
            userData:undefined,
            userServices:[],
            allServices:[],
            self:this,
            img_url:env.image_base_url,
            total_pages:0,
            }
        },
        methods:{
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
              async handleUserServiceActivation (service,user) {
                   Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.userServices.includes(service._id) ? 
                        'Êtes vous sûr de vouloir activer le service '+service._name+' à cet utilisateur ?' : 
                        'Êtes vous sûr de vouloir désactiver le service '+service._name+' à cet utilisateur ?',
                    confirmButtonText:  this.userServices.includes(service._id) ? 'Activer' :'Désactiver',
                    cancelButtonText: this.$t('cancel'),
                    showCancelButton: true,
                    cancelButtonColor:"#CCC",
                    confirmButtonColor:"#29b3a6"
                }).then( async (result )=> {
                    if (result.value) {
                            this.userId=user._id;
                            let response=undefined;
                            let icon="warning";
                            if(this.userServices.includes(service._id)){
                                response = await  this.handleActivation(service);
                                icon='success'
                            }else{
                                response = await this.handleDeactivation(service);
                            }
                            response=response.data;
                            Swal.fire({
                                icon: icon,
                                timerProgressBar: true,
                                text: 'Service '+service._name+' '+response.message
                            }).then(()=>{
                                this.getUserDataAndServices();
                            })
                    }
                })
              },
              async handleActivation (service) {
                this.serviceId = service._id;
                const response = await client({
                    method: 'post',
                    url: `/services/activation`,
                    data: {
                        _userId: this.userId,
                        _service: this.serviceId,
                    }
                })
                return response;
            },
            async handleDeactivation (service) {
                this.serviceId = service._id;
                const response = await client({
                    method: 'post',
                    url: `/services/deactivation`,
                    data: {
                        _userId: this.userId,
                        _service: this.serviceId
                    }
                })
                return response;
            },
            async getAllServices(page=1) {
                this.service_status = true                
                page=page-1;
                let response=await client({
                    method: 'post',
                    url: `/services`,
                    data: {page:page}
                })
                response=response.data;
                if(!response.error) {
                        this.serviceData = response.services
                        this.total_pages = response.total_pages
                        this.service_status = false     
                    }else{
                        console.log(error, 'error get services ****')
                        this.service_status = false
                    }
            },
            getUserDataAndServices(){
                if (this.$route.params.user_id){
                this.$store.dispatch('users/getUserAccountDetails',this.$route.params.user_id).then((result)=>{
                    this.userData=result.user;
                    this.userServices=result.services ? result.services.map(res=>{ if(res._status) return res._service;}) : [];
                    this.allServices=result.services;
                    console.log(this.userServices,'******* user services data *********')
                })
            }
            }
        },
        computed: {
            ...mapState('users/',['user'])
        },
        mounted(){
            this.getUserDataAndServices();
        },
        created() {
            this.getAllServices();
            this.checkisDashboard();
        },

    }
</script>

<style scoped>
    .circular--square {
        border-radius: 50%;
    }
    .circular--square {
        border-radius: 50% 50%;
        width: 50px;
        height: 50px;
        object-fit: contain;
    }
</style>
